import { AnchorHTMLAttributes, FC } from 'react';
import { IconLongArrowRightBold, NormalButton, Text, VStack } from '@croquiscom-pvt/zds';
import styled from '@emotion/styled';

import { argbToRgba } from '@common/utils';

import { useUblHandler } from '../../hooks/useUblHandler';
import { AdBannerBaseProps } from '../../types/AdBannerBaseProps';

interface Props extends AdBannerBaseProps, AnchorHTMLAttributes<HTMLAnchorElement> {}

export const ProductCardAdBanner: FC<React.PropsWithChildren<Props>> = ({ item, ubl_handler, onClick, href = item.landing_url, ...rest }) => {
  const { bind } = useUblHandler({ item, ubl_handler, onClick });
  const background_color = argbToRgba(item.background_color);

  return (
    <SC.Root {...rest} {...bind()} href={href} bg={background_color}>
      <SC.ImageRoot>
        <img src={item.banner_image_url} alt={item.title} />
      </SC.ImageRoot>
      <SC.CopyRoot align='center'>
        <SC.TitleRoot align='center'>
          <Text variant='Body_15_Bold' align='center'>
            {item.title}
          </Text>
          {!!item.sub_title && (
            <Text variant='Body_15_Bold' align='center'>
              {item.sub_title}
            </Text>
          )}
        </SC.TitleRoot>
        <SC.ShopName variant='Body_13_Medium' align='center' text_color={item.text_color ?? '#828A8F'}>
          {item.shop_name}
        </SC.ShopName>
        <SC.Button bg={item.button_color ?? '#34383B'} size='small' rightIcon={IconLongArrowRightBold}>
          바로가기
        </SC.Button>
      </SC.CopyRoot>
    </SC.Root>
  );
};

const SC = {
  Root: styled.a<{ bg: string }>`
    display: flex;
    flex-direction: column;
    background-color: white;

    > div {
      background-color: ${({ bg }) => bg};
    }
  `,
  ImageRoot: styled.div`
    width: 100%;
    position: relative;
    padding-top: 120%;

    img {
      position: absolute;
      left: 0;
      top: 0;
      object-fit: cover;
      width: 100%;
      height: 100%;
    }
  `,
  CopyRoot: styled(VStack)`
    padding: 20px 16px 26px;
  `,
  TitleRoot: styled(VStack)`
    > * + * {
      margin-top: 3px;
    }
  `,
  ShopName: styled(Text)<{ text_color: string }>`
    margin-top: 4px;
    color: ${({ text_color }) => text_color};
  `,
  Button: styled(NormalButton)<{ bg: string }>`
    margin-top: 20px;
    align-self: center;
    background-color: ${({ bg }) => bg};
  `,
};
